import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUp } from 'lucide-react';
import MicroLabel from '../components/MicroLabel';

/**
 * Chapter 09 — the close.
 *
 * Primary CTA into the detailed dashboard (which lives at `/` in this app, not
 * `/dashboard`), plus a ghost button back to chapter 01.
 */
function Close({ onBackToTop }) {
  return (
    <>
      <div className="story-close-body">
        <h2 className="story-close-headline">
          That&apos;s the story so far.
          <br />
          The numbers live inside.
        </h2>

        <div className="story-close-actions">
          <Link className="story-btn story-btn-primary" to="/">
            Open the detailed view
            <ArrowRight size={16} className="story-btn-icon" aria-hidden="true" />
          </Link>
          <button type="button" className="story-btn story-btn-ghost" onClick={onBackToTop}>
            Back to the top
            <ArrowUp size={16} className="story-btn-icon" aria-hidden="true" />
          </button>
        </div>
      </div>

      <div className="story-footer">
        <MicroLabel>Portfolio Tracker — all-time summary</MicroLabel>
        <MicroLabel>Updated with every login</MicroLabel>
      </div>
    </>
  );
}

export default Close;
